import React, { Children } from 'react';
import { motion } from 'framer-motion';
const images = [{
  src: 'https://cdn.magicpatterns.com/uploads/ivDR23d7Fyqv53U8p7hboc/ugc_jardin.png',
  caption: 'Relaxing outdoors'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qBZat1MbUbdvPizsVg8D9g/ugc_senior_lectura.png',
  caption: 'Reading at home'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/6TNBFVZ8wroWpBJ7PDa3us/ugc_sofa_v2.png',
  caption: 'Everyday comfort'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rEX3XFSdcNBN3jGrbyKC8X/producto_zen.png',
  caption: 'Premium design'
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    scale: 0.95
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.5
    }
  }
};
export function ProductInAction() {
  return <section className="bg-brand-gray-light py-16 lg:py-24 px-4 sm:px-6 lg:px-8" data-id="element-127">
      <div className="max-w-7xl mx-auto" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-129">
          <h2 className="text-3xl sm:text-4xl font-bold text-brand-black mb-4" data-id="element-130">
            Real People. Real Relief.
          </h2>
          <p className="text-brand-gray-dark text-lg max-w-2xl mx-auto" data-id="element-131">
            See how others are finding comfort in their daily lives.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-132">
          {images.map((img, index) => <motion.div key={index} variants={itemVariants} className="group relative overflow-hidden rounded-2xl shadow-md bg-white" data-id="element-133">
              <div className="aspect-w-1 aspect-h-1 w-full" data-id="element-134">
                <img src={img.src} alt={img.caption} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-135" />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-80" data-id="element-136"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4" data-id="element-137">
                <p className="text-white font-medium text-center" data-id="element-138">
                  {img.caption}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}